import { graphql } from 'react-relay/hooks'
import { ConnectionHandler } from 'react-relay'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportCreateMutation($input: CreateReportInput!) {
    createReport(input: $input) {
      report {
        id
        rowId
        company {
          id
        }
        ...ReportsTableRow_report
      }
    }
  }
`

const updater = (store, { createReport }) => {
  const payload = store.getRootField('createReport')
  const newReport = payload.getLinkedRecord('report')
  const company = store.get(createReport.report.company.id)

  // Add the newly-created report to the ReportsTable collection, both
  // when viewing only active reports and archived + active
  const filters = [
    { orderBy: 'CREATED_AT_DESC', includeDeleted: 'NO' },
    { orderBy: 'CREATED_AT_DESC', includeDeleted: 'YES' },
  ]

  filters.forEach((filter) => {
    const connection = ConnectionHandler.getConnection(company, 'ReportsTable_reports', filter)

    if (connection) {
      const newEdge = ConnectionHandler.createEdge(store, connection, newReport, 'ReportEdge')
      ConnectionHandler.insertEdgeBefore(connection, newEdge)
    }
  })
}

export default function useReportCreate() {
  return useMutation(mutation, 'createReport', { updater })
}
